/* eslint-disable indent */
/* eslint-disable no-new-func */
import { isString, isObject } from "lodash";

/**
 * 校验函数 body 体
 * @param {string} template 条件模板
 */
export const validate = template => {
  if (!isString(template)) {
    return {
      success: false,
      errorMsg: `${template} 须为字符串`
    };
  }

  // ${var} 内容校验

  return {
    success: true,
    errorMsg: ""
  };
};

/**
 * 获取子属性
 * @param {any} data 数据
 * @param {string} key 属性
 */
const getProperty = (data, key) => {
  if (!data) return data;

  if (key === "last" && Array.isArray(data) && !("last" in data)) {
    return data[data.length - 1];
  } else if (key === "first" && Array.isArray(data) && !("first" in data)) {
    return data[0];
  }

  if (key === "length") {
    return data.length;
  }

  if (!(key in data)) throw new Error(`${key} not in ${data}`);
  return data[key];
};

/**
 * 创建执行上下文
 * @param {*} options
 */
const createFuncContext = (options, topData) => {
  // 默认转换数据，为兼容老的 Request 配置，params.js 传入 false
  const { fieldApi, funcs, convertFlag } = options;
  return {
    get(mainKey, keyPath) {
      let data;
      const keys = keyPath && isString(keyPath) ? keyPath.split(".") : [];

      // 1. 运行时注入的数据，如响应数据等
      if (topData && isObject(topData) && mainKey in topData) {
        data = topData[mainKey];
        (keys || []).forEach(key => (data = getProperty(data, key)));
        return data;
      }

      // 2. 字段数据处理
      // 滤除未在页面显示的字段
      if (!fieldApi.isFieldExist(mainKey)) return;

      const [propName, ...subKeys] = keys;
      // 取出模型数据
      data = fieldApi.getFieldProp(mainKey, propName, convertFlag);
      subKeys.map(subKey => (data = getProperty(data, subKey)));

      return data;
    },
    funcs
  };
};

/**
 * 解析为处理函数 "${fieldId}.value.value === 'SMLH'" => function
 * @param {string} template 条件模板 "${fieldId}.value.value === 'SMLH'"
 * @return {object} () => {}
 */
export const parse = (template, options = {}) => {
  const validateResult = validate(template);
  console.warn(validateResult.success, validateResult.errorMsg);

  // 运行时传入 data，如响应数据 { res }，以便应用于模板解析
  return data => {
    const context = createFuncContext(options, data);
    // 解析变量 "${var}.key" 或函数 "getAgeFromIdcard"
    // 1. 将 "getAgeFromIdcard(${fieldId}.value)" 替换成 "funcs.getAgeFromIdcard(${fieldId}.value)"
    // 2. 将 "${fieldId}.value" 替换成 "get(fieldId, 'value')"
    // 3. 为 "funcs.getAgeFromIdcard" 函数添加 this 上下文
    const funcBody = template
      .replace(/([a-zA-Z\.]*[a-zA-Z])\([^\)]*\)/g, ($0, $1) => {
        if ($1) {
          return `funcs.${$0}`;
        }
        return $0;
      })
      .replace(/(\${([^}\s]*)})(\.([^\s\)]*))?/g, ($0, ...rest) => {
        if (rest[1]) {
          const keyPath = rest[3] ? `"${rest[3]}"` : rest[3];
          return `get("${rest[1]}", ${keyPath})`;
        }
        return $0;

        // 解析函数 "get(a, b)"
      })
      .replace(/([a-zA-Z\.]*[a-zA-Z])\(/g, ($0, $1) => {
        if ($1) {
          return `this.${$0}`;
        }
        return $0;
      });

    // 没有函数，当做字符串处理
    return funcBody.match(/([a-zA-Z\.]*[a-zA-Z])\(/g)
      ? new Function(
          `
        var result;
        try {
          result = ${funcBody};
        } catch(err) {
          console.warn(err);
        };

        return result;
      `
        ).call(context)
      : funcBody;
  };
};
